export const getLink = link => {
  if (link && (link.indexOf('/http:') > -1 || link.indexOf('/https:') > -1)) {
    link = link.slice(1)
  } else if (link && link.indexOf('http') < 0 && link.indexOf('//') > -1) {
    link = link.replace(/\/\//g, '/')
  }
  return link
}
